import {
  DashboardModule,
  Form,
  Grid,
  SectionDivider,
} from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import TagInputField from './TagInputField'

const renderEnergyRatingOptions = () => {
  const options = []

  for (let index = 0.5; index <= 10; index += 0.5){
    options.push(
      <option value={index} key={`energy_rating_option_${index}`}>
        {index.toFixed(1)} Stars
      </option>,
    )
  }

  return options
}

interface ExtraDetailsProps {
  campaignForm: UseFormPayload,
}

const ExtraDetails = (props: ExtraDetailsProps) => {
  const { campaignForm } = props

  const {
    entityState: {
      energy_rating,
      property_url,
    },
    handlers,
  } = campaignForm

  const tagInputFields = ['heating', 'flooring', 'exterior', 'roof', 'additional_garaging', 'chattels']

  return (
    <DashboardModule title="Extra Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Property URL">
            <input
              name="property_url"
              type="text"
              value={property_url}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Energy Rating" marginTop={['large', 0]}>
            {/*
             // @ts-expect-error TS2322 */}
            <select name="energy_rating" value={energy_rating} {...handlers}>
              <option value="">Please Select...</option>
              {renderEnergyRatingOptions()}
            </select>
          </Form.Field>
        </Form.Row>

        <SectionDivider boxProps={{ marginTop: 'large' }}>Selected Extra Details</SectionDivider>

        {/*
         // @ts-expect-error TS2322 */}
        <Grid gridRowGap="large" marginTop="medium">
          {tagInputFields.map(tagInputField => (
            <TagInputField
              fieldKey="extra_fields"
              fieldName={tagInputField}
              key={tagInputField}
              formPayload={campaignForm}
            />
          ))}
        </Grid>
      </Form>
    </DashboardModule>
  )
}

export default ExtraDetails
